import { createFileRoute } from '@tanstack/react-router';

import { DriversViewPage } from '@/areas/manufacturing-templates/Drivers/DriversView/DriversViewPage';
import { canViewManufacturing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/manufacturing/drivers/')({
    staticData: { access: { permissions: canViewManufacturing }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <DriversViewPage />;
}
